"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("@toca.ui/config");
var brand = config_1.BrandConfiguration.GetBrandConfiguration();
var BrandColorsType = /** @class */ (function () {
    function BrandColorsType() {
    }
    var _a, _b, _c, _d, _e, _f, _g;
    BrandColorsType.greenDefault = (_a = brand.brandStyling.defaultColor) !== null && _a !== void 0 ? _a : '#647c36';
    BrandColorsType.greenMedium = (_b = brand.brandStyling.defaultColorMedium) !== null && _b !== void 0 ? _b : '#76BC4C';
    BrandColorsType.greenLight = (_c = brand.brandStyling.defaultColorLight) !== null && _c !== void 0 ? _c : '#B4DA9D';
    BrandColorsType.greenLighter = (_d = brand.brandStyling.defaultColorLighter) !== null && _d !== void 0 ? _d : '#EFF7EA';
    BrandColorsType.greenTextLight = '#c5e3b5';
    BrandColorsType.darkGreen = (_e = brand.brandStyling.defaultColorDark) !== null && _e !== void 0 ? _e : '#759D56';
    BrandColorsType.darkGreen_WCAG = (_f = brand.brandStyling.defaultColorDark_WCAG) !== null && _f !== void 0 ? _f : '#647D45';
    BrandColorsType.brightGreen = '#64AD42';
    BrandColorsType.charcoalGreen = (_g = brand.brandStyling.defaultColorCharcoal) !== null && _g !== void 0 ? _g : '#485550';
    BrandColorsType.darkGrey = '#A19C91';
    BrandColorsType.lightGrey = '#f2f2f2';
    BrandColorsType.backgroundLightGrey = '#aaa';
    BrandColorsType.textLightGrey = '#ccc';
    BrandColorsType.whiteGrey = '#bbbbbb';
    BrandColorsType.greyLightest = '#e8e8e8';
    BrandColorsType.white = '#fff';
    BrandColorsType.lightDullBlack = '#333333';
    BrandColorsType.dullBlack = '#222';
    BrandColorsType.black = '#000';
    BrandColorsType.lighterBlack = '#2a322e';
    BrandColorsType.brownDark = '#32302C';
    BrandColorsType.brownDefault = '#423F39';
    BrandColorsType.brownMedium = '#5F574E';
    BrandColorsType.brownLight = '#8D8980';
    BrandColorsType.brownLighter = '#D4D2CC';
    BrandColorsType.brownLightest = '#F1F0EF';
    BrandColorsType.redDefault = '#EB5C18';
    BrandColorsType.cornflowerBlue = '#76a7db';
    BrandColorsType.blue = '#0071bc';
    BrandColorsType.silver = '#c0cece';
    BrandColorsType.linkColor = '#5f79c2';
    BrandColorsType.pageHeaderColor = '#E4E4E4';
    BrandColorsType.mango = '#ffb728';
    BrandColorsType.redErrorBackground = '#494949';
    BrandColorsType.lightBlack = '#FFB2B9';
    BrandColorsType.lighterGreen = '#E5EBD8';
    BrandColorsType.forest = '#485556';
    BrandColorsType.forestLight = '#7c9189';
    BrandColorsType.forestLighter = '#c3d8d1';
    BrandColorsType.greyLighter = '#f5f5f5';
    BrandColorsType.greenDark = '#617124';
    BrandColorsType.squircleBorder = '#99aca5';
    BrandColorsType.asparagus = '#8cad4d';
    BrandColorsType.deepOrange = '#e65800';
    BrandColorsType.lightOrange = '#FDEFE0';
    BrandColorsType.linkGreen = '#647c36';
    BrandColorsType.buttonBgColor = '#7a9843';
    BrandColorsType.whiteSmoke = '#F5F5F5';
    BrandColorsType.coolGrey = '#99ACA5';
    BrandColorsType.salmonDark = '#FA8072';
    BrandColorsType.navyBlue = '#0071BC';
    BrandColorsType.primary200 = '#B9CDCC';
    BrandColorsType.primary300 = '#C0C5C3';
    BrandColorsType.primary500 = '#0B6E69';
    BrandColorsType.primary900 = '#1E3029';
    BrandColorsType.success500 = '#017955';
    BrandColorsType.error500 = '#C03A26';
    BrandColorsType.primary100 = '#4AC4AC';
    return BrandColorsType;
}());
exports.default = BrandColorsType;
//# sourceMappingURL=colors.js.map